<template >


  <section>
       <!-- Content Header (Page header) -->
       <section class="content-header">
          <h1>
             PAPELETAS
             <small>Percy</small>
          </h1>
          <ol class="breadcrumb">
             <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
             <li class="active">Ver Papeleta</li>
          </ol>
       </section>
       <!-- Main content -->
       <section class="content">

          <div class="row">
          <!-- left column -->
            <div class="col-md-12">
               <!-- general form elements -->
               <div class="box box-primary">

                <div class="box-header with-border">
                   <h3 class="box-title">Detalle:</h3>
                </div>

                  <!-- /.box-header -->
                  <!-- form start -->
                <div class="row">

                        <div class="col-md-12">


                          <div class="col-md-12">
                             <div class="form-group">
                                <label>AREAS DE APLICACION</label>
                                <input type="text" disabled  class="form-control"  placeholder="Company" value="Creative Code Inc.">
                             </div>
                          </div>

                          <div class="col-md-12">

                              <div class="col-md-6">
                                <div class="form-group">
                                  <p>ACCION A REALIZAR</p>

                                   <select class="form-control">
                                     <option>Autorizar </option>
                                   </select>
                               </div>
                              </div>
                              <div class="col-md-6">

                                <div class="form-group">
                                  <p>(<small>Haga click para iniciar proceso</small>)</p>

                                  <button class="btn btn-light"> <i class="fa fa-check"></i> Procesar</button>
                               </div>

                              </div>
                          </div>


                           <!--

                            <button class="btn btn-light">
                             <i class="fa fa-trash"> Eliminar</i>
                           </button>
                        -->

                        </div>
                </div>


                <div class="content table-responsive table-full-width" >
               <table class="table table-condensed">
                  <thead>
                     <tr class="active">
                        <th>TRABAJADOR</th>
                        <th>TIPO DE PAPELETA</th>
                        <th>FECHA DE INICIO</th>
                        <th>FECHA DE TERMINO</th>
                        <th>MOTIVO</th>
                        <th>FEC.REG</th>
                        <th>AREA</th>
                        <th>APROBAR</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr v-for="papeleta in papeletas">
                        <td data-title="CÓDIGO">1</td>
                        <td data-title="NÚMERO">{{papeleta.descripcion}}</td>
                        <td data-title="DEMANDANTE">{{papeleta.fechainicio}}</td>
                        <td data-title="DEMANDANTE">{{papeleta.fechafin}}</td>
                        <td data-title="DEMANDANTE">{{papeleta.observacion}}</td>
                        <td data-title="DEMANDANTE">{{papeleta.registerdate}}</td>
                        <td data-title="VER">

                        </td>
                        <td>


                            <span rel="tooltip" title="Editar" data-state="primary"
                            data-placement="right" class="fa fa-check btn btn-facebook"
                            @click="aprovePapleta(papeleta)"></span>


                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>



          </div>




                  <br>



               </div>
               <!-- /.box -->
            </div>

        </div>
     </section>
  </section>


</template>

<script>


  import config from '../../config';

export default {
  name : 'Autorizacion',
  data() {
    return {

        alg : [1,3,5,6,7,3],
        papeletas : []
    }
  },
  mounted(){

    //trear papeletas

    axioss.get(config.serverURI + 'aplicaciones/papeletas_aprobar/100255')
      .then((response)=>{
        console.log('Responde autorizacion',response.data);
        let data = response.data;

        this.papeletas = data;


      })

  },

  methods : {

    aprovePapleta(papeleta){

      console.log('aproveramoes ',papeleta);
      papeleta.idpapeleta = 'LIMABGT 000000000614';
      axioss.get(config.serverURI + 'aplicaciones/aprovarpapeleta/'+papeleta.idpapeleta+'/100255')
        .then((response)=>{
          swal("Aprobado.")
        })

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/Autorizacion.vue